import AppointmentConfirmationDialog from './AppointmentConfirmationDialog'

export default AppointmentConfirmationDialog
